const defaultParams = {
	slidesPerView: 1,
	loop: true,
	wrapperTag: 'div',
	tag: 'div',
	slideTag: 'div',
}

export default defaultParams;